var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QDynamicSubmenu',_vm._g({attrs:{"base-url":"/leads","default-title":_vm.title,"default-buttons":_vm.buttons,"titlelink":_vm.titlelink,"sticky":false,"standard-submenu":""}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }